import { Booking, type MicroCopy, type Search } from '@vakantiesnl/types';
import { type LuggageType } from '@vakantiesnl/types/src/booking';

import { inject } from './template';

export const getPersonName = (
	microCopy: MicroCopy,
	ageType: Booking.AgeType,
	personNumber: number,
): string | undefined => {
	switch (ageType) {
		case Booking.AgeType.ADULT:
			return `${microCopy['common.adult']} ${personNumber}${
				personNumber === 1 ? ` (${microCopy['booking.mainBooker']})` : ''
			}`;
		case Booking.AgeType.CHILD:
			return `${microCopy['common.child']} ${personNumber}`;
		case Booking.AgeType.BABY:
			return `${microCopy['common.baby']} ${personNumber}`;
		default:
			return undefined;
	}
};

export const luggageGroupName = (
	type: LuggageType,
	weight: number,
	isPriorityBoarding: boolean,
	groupCount: number,
	microCopies: MicroCopy,
): string => {
	const luggageText = inject(
		type === 'hold' ? microCopies['cashslip.luggageGroup'] : microCopies['cashslip.cabinLuggageGroup'],
		{
			weight: `${weight}`,
			amount: `${groupCount}`,
		},
	).join('');

	return `${luggageText}${isPriorityBoarding ? ` (${microCopies['booking.cabinLuggage.priorityBoarding']})` : ''}`;
};

export const luggageGroupNamePieces = (weight: number, groupCount: number, microCopies: MicroCopy): string =>
	inject(microCopies['booking.confirmation.luggageGroup'], {
		weight: `${weight}`,
		amount: `${groupCount}`,
	}).join('');

const getNumberOfAgeType = (persons: Booking.Persons, type: Booking.AgeType): number =>
	persons.items.filter(({ ageType }) => ageType === type).length;

export const getNumberOfAdults = (persons: Booking.Persons): number =>
	getNumberOfAgeType(persons, Booking.AgeType.ADULT);

export const getNumberOfChildren = (persons: Booking.Persons): number =>
	getNumberOfAgeType(persons, Booking.AgeType.CHILD);

export const getNumberOfBabies = (persons: Booking.Persons): number =>
	getNumberOfAgeType(persons, Booking.AgeType.BABY);

export const convertPersonsToParty = (persons: Booking.Persons): Search.Party => {
	return {
		adults: getNumberOfAdults(persons),
		children: getNumberOfChildren(persons),
		babies: getNumberOfBabies(persons),
		total: persons.items.length,
	};
};
